import { ProgramModule_map, ProgramModule_withSetState, ProgramModule_runWith, ProgramModule_init } from "../Fable.Elmish.4.2.0/program.fs.js";
import { Cmd_none } from "../Fable.Elmish.4.2.0/cmd.fs.js";
import { equals, disposeSafe, isDisposable, uncurry2, uncurry3 } from "../fable-library-js.4.19.0/Util.js";
import { class_type } from "../fable-library-js.4.19.0/Reflection.js";
import { useSyncExternalStore, useState } from "react";

class Util_ElmishState$3 {
    constructor(program, arg, dependencies) {
        this.arg = arg;
        this.dependencies = dependencies;
        const program_1 = program();
        let patternInput_1;
        const patternInput = ProgramModule_init(program_1)(this.arg);
        patternInput_1 = [[patternInput[0], (_arg) => {
        }], patternInput[1]];
        this.state = patternInput_1[0];
        this.cmd = patternInput_1[1];
        this.subscribe = ((callback) => {
            let dispose = false;
            ProgramModule_runWith(this.arg, ProgramModule_withSetState((model_2, dispatch) => {
                const oldModel = this.state[0];
                this.state = [model_2, dispatch];
                if (!(model_2 === oldModel)) {
                    callback();
                }
            }, ProgramModule_map((_init, _arg_1) => {
                const cmd$0027 = this.cmd;
                this.cmd = Cmd_none();
                return [this.state[0], cmd$0027];
            }, uncurry3((x) => x), uncurry3((x_1) => x_1), uncurry3((x_2) => x_2), uncurry2((x_3) => x_3), (tupledArg) => [(msg) => (tupledArg[0](msg) ? true : dispose), (model_1) => {
                const matchValue = model_1;
                if (isDisposable(matchValue)) {
                    const disp = matchValue;
                    disposeSafe(disp);
                }
                else {
                    tupledArg[1](model_1);
                }
            }], program_1)));
            return () => {
                dispose = true;
            };
        });
    }
}

function Util_ElmishState$3_$reflection(gen0, gen1, gen2) {
    return class_type("Fable.React.UseElmish.Util.ElmishState`3", [gen0, gen1, gen2], Util_ElmishState$3);
}

function Util_ElmishState$3_$ctor_Z29FF63CF(program, arg, dependencies) {
    return new Util_ElmishState$3(program, arg, dependencies);
}

function Util_ElmishState$3__get_State(_) {
    return _.state;
}

function Util_ElmishState$3__get_Subscribe(_) {
    return _.subscribe;
}

function Util_ElmishState$3__IsOutdated_1954DBC6(_, arg$0027, dependencies$0027) {
    if (!equals(_.arg, arg$0027)) {
        return true;
    }
    else {
        return !equals(_.dependencies, dependencies$0027);
    }
}

export function React_useElmish_Z6C327F2E(program, arg, dependencies) {
    const patternInput = useState(() => Util_ElmishState$3_$ctor_Z29FF63CF(program, arg, dependencies));
    const state = patternInput[0];
    if (Util_ElmishState$3__IsOutdated_1954DBC6(state, arg, dependencies)) {
        patternInput[1](Util_ElmishState$3_$ctor_Z29FF63CF(program, arg, dependencies));
    }
    return useSyncExternalStore(Util_ElmishState$3__get_Subscribe(state), () => Util_ElmishState$3__get_State(state));
}

//# sourceMappingURL=Fable.React.UseElmish.fs.js.map
